var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpendCategoryHealth32(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DDL-CBA---Icons-Mobile",
    transform: "translate(-1902.000000, -732.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon//SpendCategory/Health32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounding-box",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconHealth",
    transform: "translate(5.000000, 7.000000)",
    fill: "#706D6E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Heart"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2167604,17.9235552 L18.6881372,9.37727588 L18.7638369,9.29961974 C19.6848384,8.45204599 20.2222222,7.24188471 20.2222222,5.93774507 C20.2222222,3.4496582 18.2754012,1.44444444 15.8888889,1.44444444 C14.3031442,1.44444444 12.8649136,2.3355164 12.1025908,3.75052608 L11.2222222,5.38465029 L10.3418536,3.75052608 C9.57953081,2.3355164 8.14130029,1.44444444 6.55555556,1.44444444 C4.16904329,1.44444444 2.22222222,3.4496582 2.22222222,5.93774507 C2.22222222,7.27080912 2.78392388,8.50519092 3.74050877,9.35374284 L3.8309338,9.44498495 L11.2167604,17.9235552 Z M10.6027277,2.35996523 C10.765564,2.61410522 11.1341998,3.11285044 11.2222222,3.27623599 C11.3102446,3.11285044 11.6626587,2.59329224 11.8417168,2.35996523 C12.8198304,1.18724148 14.2701409,0.444444444 15.8888889,0.444444444 C18.8344076,0.444444444 21.2222222,2.90387891 21.2222222,5.93774507 C21.2222222,7.56638723 20.5341102,9.0294917 19.4410027,10.0354502 L11.2154185,19.4444444 L3.07690794,10.1018297 C1.94125487,9.09443286 1.22222222,7.60257707 1.22222222,5.93774507 C1.22222222,2.90387891 3.61003689,0.444444444 6.55555556,0.444444444 C8.17430351,0.444444444 9.62461401,1.18724148 10.6027277,2.35996523 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Beat",
    points: "8 10 0 10 0 9 7.48761651 9 9.71026894 5.1 11.4880467 11.3222222 12.8209498 9 22 9 22 10 13.4012724 10 11.17862 13.8792835 9.40084217 7.65706127"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpendCategoryHealth32);
export default __webpack_public_path__ + "static/media/spendCategoryHealth32.2b51e4e9d71b159c8286b8d76c49c386.svg";
export { ForwardRef as ReactComponent };